// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2244":"e623b7dc","7736":"e623b7dc"}[chunkId] + ".chunk.css";
};